export const DB_NAME = 'AL_CORE_STUDY_TRACKER';
export const DB_VERSION = 4;

export const STORES = {
  subjects: 'subjects',
  syllabusUnits: 'syllabusUnits',
  chapters: 'chapters',
  topics: 'topics',
  pastPapers: 'pastPapers',
  paperTopicLinks: 'paperTopicLinks',
  studySessions: 'studySessions',
  tasks: 'tasks',
  revisionEvents: 'revisionEvents',
  exams: 'exams',
  goals: 'goals',
  studentProfile: 'studentProfile',
  changeJournal: 'changeJournal',
  syncCheckpoints: 'syncCheckpoints',
  conflictRecords: 'conflictRecords',
} as const;

export type StoreName = (typeof STORES)[keyof typeof STORES];
